function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarSucceedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.55 5h-3V3h-2v2h-12V3h-2v2h-3a2 2 0 00-2 2v7h26V7a2 2 0 00-2-2zm0 7h-22V7h3v3h2V7h12v3h2V7h3v5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.043 27H4.55V16h-2v11a2 2 0 002 2h11.493v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55 20v-2h-4v2h4zM11.55 22v2h-4v-2h4zM16.853 20v-2h-3.3v2h3.3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.616 18.236l-7.845 9.95-5.355-4.256 1.244-1.566 3.784 3.007 6.602-8.373 1.57 1.238z",
    fill: props.color
  }));
}

export default SvgIconCalendarSucceedFilled;